import React, { useEffect } from 'react';
import { useInstallPWA } from '../hooks/useInstallPWA';

/**
 * Component that adds a CSS class to the body when the app is running
 * as a PWA on iOS to handle safe areas correctly
 */
const IOSSafeArea: React.FC = () => {
  const { isIOS, isInStandaloneMode } = useInstallPWA();

  useEffect(() => {
    // Only apply these changes for iOS devices in standalone mode (PWA installed)
    if (isIOS && isInStandaloneMode) {
      // Add a class to the body element
      document.body.classList.add('ios-pwa');
      
      // Create a style element for additional iOS-specific styles
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        /* iOS PWA specific inline styles */
        @supports (padding-top: env(safe-area-inset-top)) {
          body.ios-pwa {
            /* Add padding to account for the notch and status bar */
            padding-top: env(safe-area-inset-top);
          }
        }
      `;
      document.head.appendChild(styleElement);
      
      return () => {
        // Clean up
        document.body.classList.remove('ios-pwa');
        document.head.removeChild(styleElement);
      };
    }
  }, [isIOS, isInStandaloneMode]);

  // This component doesn't render anything
  return null;
};

export default IOSSafeArea;
